import { RecordMask } from '@skinsoft/types'

/* tslint:disable:object-literal-sort-keys */

// tslint:disable-next-line:variable-name
export const summaryAreaRecordMasks: RecordMask = {
    name: {
        translatedString: {
            fr: 'Masque Reporter',
        },
        translatedId: null,
    },
    categories: [
        {
            label: {
                translatedString: {
                    fr: '',
                    'fr-ca': '',
                    en: '',
                    'en-us': '',
                    nl: '',
                    es: '',
                    it: '',
                    no: '',
                    de: '',
                    se: '',
                },
                translatedId: null,
            },
            maskFields: [
                {
                    columnDisplay: null,
                    entityField: {
                        entityFieldId: "5e7b836714256b1944f069f9",
                        "className": "org.skinsoft.backend.types.entityfield.EntityField",
                        "entity": "conditionReport",
                        "schema": "conditionReportCS",
                        "name": "stateOfConservations",
                        "mandatorySystem": false,
                        "type": {
                            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ListEntityFieldType",
                            "type": "List",
                            "entityFieldType": {
                                "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                "type": "StateOfConservation"
                            },
                            "listClass": "org.skinsoft.backend.schemas.conditionreportcs.complex.StateOfConservation"
                        },
                        "entityFields": [
                            {
                                entityFieldId: "5e7b836714256b1944f069f7",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "conditionReport",
                                "schema": "conditionReportCS",
                                "name": "typeStateOfConservation",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ThesaurusEntityFieldType",
                                    "type": "ThesaurusTerm",
                                    "thesaurusIdentifier": "typeStateOfConservation"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "conditionReportCS.stateOfConservations.typeStateOfConservation",
                                "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List|org.skinsoft.backend.types.thesaurusterm.ThesaurusTerm",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523142309",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            {
                                entityFieldId: "5e7b836714256b1944f069f6",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "conditionReport",
                                "schema": "conditionReportCS",
                                "name": "stateOfConservation",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ThesaurusEntityFieldType",
                                    "type": "ThesaurusTerm",
                                    "thesaurusIdentifier": "stateOfConservation"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "conditionReportCS.stateOfConservations.stateOfConservation",
                                "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List|org.skinsoft.backend.types.thesaurusterm.ThesaurusTerm",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523142308",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            {
                                entityFieldId: "5e7b836714256b1944f069f8",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "conditionReport",
                                "schema": "conditionReportCS",
                                "name": "precision",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                    "type": "TranslatedString"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "conditionReportCS.stateOfConservations.precision",
                                "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List|org.skinsoft.backend.types.translatedstring.TranslatedString",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523142310",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                        ],
                        "isChildren": false,
                        "isInList": false,
                        "path": "conditionReportCS.stateOfConservations",
                        "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List",
                        "isReadOnly": false,
                        "isComputed": false,
                        "weight": 1.0,
                        "needId": false,
                        "usableForFacets": false,
                        "isFieldConditionNumbering": false,
                        "lastModificationTimestamp": "1722523142311",
                        "backwardSearchEnable": false,
                        "fieldExcludeCheckInstitution": false
                    },
                    children: [
                        {
                            columnDisplay: null,
                            entityField: {
                                entityFieldId: "5e7b836714256b1944f069f7",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "conditionReport",
                                "schema": "conditionReportCS",
                                "name": "typeStateOfConservation",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ThesaurusEntityFieldType",
                                    "type": "ThesaurusTerm",
                                    "thesaurusIdentifier": "typeStateOfConservation"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "conditionReportCS.stateOfConservations.typeStateOfConservation",
                                "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List|org.skinsoft.backend.types.thesaurusterm.ThesaurusTerm",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523142309",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            children: null,
                            fieldFormat: undefined,
                            formatter: undefined,
                            inputComponent: undefined,
                            mandatoryUser: false,
                            order: 0,
                            tableDisplay: undefined
                        },
                        {
                            columnDisplay: null,
                            entityField: {
                                entityFieldId: "5e7b836714256b1944f069f6",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "conditionReport",
                                "schema": "conditionReportCS",
                                "name": "stateOfConservation",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ThesaurusEntityFieldType",
                                    "type": "ThesaurusTerm",
                                    "thesaurusIdentifier": "stateOfConservation"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "conditionReportCS.stateOfConservations.stateOfConservation",
                                "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List|org.skinsoft.backend.types.thesaurusterm.ThesaurusTerm",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523142308",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            children: null,
                            fieldFormat: undefined,
                            formatter: undefined,
                            inputComponent: undefined,
                            mandatoryUser: false,
                            order: 0,
                            tableDisplay: undefined
                        },
                        {
                            columnDisplay: null,
                            entityField: {
                                entityFieldId: "5e7b836714256b1944f069f8",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "conditionReport",
                                "schema": "conditionReportCS",
                                "name": "precision",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                    "type": "TranslatedString"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "conditionReportCS.stateOfConservations.precision",
                                "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List|org.skinsoft.backend.types.translatedstring.TranslatedString",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523142310",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            children: null,
                            fieldFormat: undefined,
                            formatter: undefined,
                            inputComponent: undefined,
                            mandatoryUser: false,
                            order: 0,
                            tableDisplay: undefined
                        },
                    ],
                    fieldFormat: undefined,
                    formatter: undefined,
                    inputComponent: undefined,
                    mandatoryUser: false,
                    order: 0,
                    tableDisplay: undefined
                },
                {
                    columnDisplay: null,
                    entityField: {
                        entityFieldId: "5d4c49000de7d241b997e14b",
                        "className": "org.skinsoft.backend.types.entityfield.EntityField",
                        "entity": "conditionReport",
                        "schema": "conditionReportCS",
                        "name": "predictInterventions",
                        "mandatorySystem": false,
                        "type": {
                            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ListEntityFieldType",
                            "type": "List",
                            "entityFieldType": {
                                "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                "type": "PredictIntervention"
                            },
                            "listClass": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.complex.PredictIntervention"
                        },
                        "entityFields": [
                            {
                                entityFieldId: "5d4c49000de7d241b997e149",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "conditionReport",
                                "schema": "conditionReportCS",
                                "name": "typeIntervention",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ThesaurusEntityFieldType",
                                    "type": "ThesaurusTerm",
                                    "thesaurusIdentifier": "typeIntervention"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "conditionReportCS.predictInterventions.typeIntervention",
                                "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List|org.skinsoft.backend.types.thesaurusterm.ThesaurusTerm",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523142346",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            {
                                entityFieldId: "5d4c49000de7d241b997e14a",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "conditionReport",
                                "schema": "conditionReportCS",
                                "name": "precision",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                    "type": "TranslatedString"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "conditionReportCS.predictInterventions.precision",
                                "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List|org.skinsoft.backend.types.translatedstring.TranslatedString",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523142348",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                        ],
                        "isChildren": false,
                        "isInList": false,
                        "path": "conditionReportCS.predictInterventions",
                        "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List",
                        "isReadOnly": false,
                        "isComputed": false,
                        "weight": 1.0,
                        "needId": false,
                        "usableForFacets": false,
                        "isFieldConditionNumbering": false,
                        "lastModificationTimestamp": "1722523142350",
                        "backwardSearchEnable": false,
                        "fieldExcludeCheckInstitution": false
                    },
                    children: [
                        {
                            columnDisplay: null,
                            entityField: {
                                entityFieldId: "5d4c49000de7d241b997e149",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "conditionReport",
                                "schema": "conditionReportCS",
                                "name": "typeIntervention",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ThesaurusEntityFieldType",
                                    "type": "ThesaurusTerm",
                                    "thesaurusIdentifier": "typeIntervention"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "conditionReportCS.predictInterventions.typeIntervention",
                                "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List|org.skinsoft.backend.types.thesaurusterm.ThesaurusTerm",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523142346",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            children: null,
                            fieldFormat: undefined,
                            formatter: undefined,
                            inputComponent: undefined,
                            mandatoryUser: false,
                            order: 0,
                            tableDisplay: undefined
                        },
                        {
                            columnDisplay: null,
                            entityField: {
                                entityFieldId: "5d4c49000de7d241b997e14a",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "conditionReport",
                                "schema": "conditionReportCS",
                                "name": "precision",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                    "type": "TranslatedString"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "conditionReportCS.predictInterventions.precision",
                                "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List|org.skinsoft.backend.types.translatedstring.TranslatedString",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523142348",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            children: null,
                            fieldFormat: undefined,
                            formatter: undefined,
                            inputComponent: undefined,
                            mandatoryUser: false,
                            order: 0,
                            tableDisplay: undefined
                        },
                    ],
                    fieldFormat: undefined,
                    formatter: undefined,
                    inputComponent: undefined,
                    mandatoryUser: false,
                    order: 0,
                    tableDisplay: undefined
                },
            ],
        },
    ],
    level: 'adminLevel',
    userId: '595ca6a7857aba0001a00001',
    entityTargetId: '736bb6b8857abf0001ac9888',
    entityTarget: 'recolement',
    isInputMask: true,
    categoriesDisplay: true,
    workspaceCreation: '5d6917c3fb6ee95ed082f268',
    workspaceSharing: [],
    isPatternMask: false,
    pattern: null,
    _links: {
        self: {
            href: 'http://127.0.0.1:8081/record-masks/6070579b0a6d211f1520a650',
        },
        'record-masks': {
            href: 'http://127.0.0.1:8081/record-masks/6070579b0a6d211f1520a650',
        },
        'mask-fields': {
            href: 'http://127.0.0.1:8081/record-masks/6070579b0a6d211f1520a650/mask-fields',
        },
    },
    id: '6070579b0a6d211f1520a650',
}
